const routes = [
    {
        path: '', name: 'home',
        component: () => import('@/views/Accueil')
    },
    {
        path: "/demande-diff",
        name: "DemandeDiff",
        component: () => import("@/views/DemandeDiff"),
        props: true
    },
    {
        path: "/correctionInformation",
        name: "CorrectionDemande",
        component: () => import("@/views/CorrectionDemande"),
        props: true
    },
    {
        path: "/page-erreur",
        name: "pageErreur",
        component: () => import("@/views/pageErreur"),
        props: true
    },
    {
        path: "/detail-actualite/:id",
        name: "detail-actualite",
        component: () => import("@/views/detailActualite"),
        props: true
    },
    {
        path: "/detail-formation/:id",
        name: "detail-formation",
        component: () => import("@/views/detailFormation"),
        props: true
    },
    {
        path: "/participer",
        name: "participer",
        component: () => import("@/views/Participer.vue"),
        props: true
    },
    {
        path: "/mot-du-president",
        name: "mot-du-president",
        component: () => import("@/views/portail/motPresident.vue"),
        props: true
    },
    {
        path: "/modele-docmument",
        name: "modele-docmument",
        component: () => import("@/views/portail/modelDocument.vue"),
        props: true
    },
    {
        path: "/texte-fondamentaux",
        name: "texte-fondamentaux",
        component: () => import("@/views/portail/texteFondamentaux.vue"),
        props: true
    },
    {
        path: "/presentation-missions",
        name: "presentation-missions",
        component: () => import("@/views/portail/mission.vue"),
        props: true
    },
    {
        path: "/assemble-general",
        name: "assemble-general",
        component: () => import("@/views/portail/assemble.vue"),
        props: true
    },
    {
        path: "/conseil-ordre",
        name: "conseil-ordre",
        component: () => import("@/views/portail/conseil.vue"),
        props: true
    },
    {
        path: "/comites",
        name: "comites",
        component: () => import("@/views/portail/comite.vue"),
        props: true
    },
    {
        path: "/condition-inscription",
        name: "condition-inscription",
        component: () => import("@/views/portail/conditionInscription.vue"),
        props: true
    },
    {
        path: "/procedure",
        name: "procedure",
        component: () => import("@/views/portail/procedure.vue"),
        props: true
    },
    {
        path: "/formation-list",
        name: "formation-list",
        component: () => import("@/views/portail/formationList.vue"),
        props: true
    },
    {
        path: "/actualite-list",
        name: "actualite-list",
        component: () => import("@/views/portail/actualiteList.vue"),
        props: true
    },
    {
        path: "/contact",
        name: "contact",
        component: () => import("@/views/portail/nousContacter.vue"),
        props: true
    },
    {
        path: "/personnes-physiques",
        name: "personnes-physiques",
        component: () => import("@/views/portail/ListExpertComptable.vue"),
        props: true
    },
    {
        path: "/cga",
        name: "cga",
        component: () => import("@/views/portail/ListCGA.vue"),
        props: true
    },
    {
        path: "/condition-generale-utilisation",
        name: "condition-generale-utilisation",
        component: () => import("@/views/portail/cgu.vue"),
        props: true
    },
    {
        path: "/mentions-legales",
        name: "mentions-legales",
        component: () => import("@/views/portail/mentionsLegales.vue"),
        props: true
    },
    

];

export default [
    {
        path: '/',
        component: () => import('@/views/espace/Home'),
        children: [...routes]
    },
    {
        path: '/inscription',
        name: 'signup',
        component: () => import('@/views/Signup'),
        beforeEnter: (to, from, next) => {
            const emailValid = localStorage.getItem("emailValid");

            if (!emailValid) {
                next({ name: "emailValidation" });
            } else {
                next(); 
            }
        },
    },
    {
        path: '/email-validation',
        name: 'emailValidation',
        component: () => import('@/views/Validation.vue')
    },
    {
        path: '/suivre-demande',
        name: 'suivre-demande',
        component: () => import('@/views/suiviDemande.vue')
    },

]